export default __webpack_public_path__ + "static/187-8d4f1882e55c36d614f2260fb473483c.jpg";